import mixpanel from 'mixpanel-browser';

export enum MEvents {
  PageViewed = 'me-lemon_page_view',
  FieldUpdated = 'me-lemon_field_update',
  SessionEnd = 'me-lemon_session_end',
  SessionStart = 'me-lemon_session_start',
  AICallStarted = 'me-lemon_profile_clarifications_dev_AI_call_started',
  AICallRestarted = 'me-lemon_profile_clarifications_dev_AI_call_restarted',
  AICallEnded = 'me-lemon_profile_clarifications_dev_AI_call_ended',
  AICallMuted = 'me-lemon_profile_clarifications_dev_AI_call_muted',
  CallCompleted = 'me-lemon_profile_clarifications_dev_call_completed',
  CallRatingStepCompleted = 'me-lemon_profile_clarifications_dev_call_rating_step_completed',
  SidebarNavClicked = 'me-lemon_sidebar_nav_clicked',
  ProfileCompleted = 'me-lemon_profile_completed',
  TestCompleted = 'me-lemon_test_is_completed',
  MarkCallCompleted = 'me-lemon_mark_is_completed',
  RecruiterCallAvailable = 'me-lemon_recruiter_call_is_availabe',
  RecruiterCallBooked = 'me-lemon_recruiter_call_is_booked',
  RecruiterCallCompleted = 'me-lemon_recruiter_call_is_completed',
  RecruiterCallSkipped = 'me-lemon_recruiter_call_is_skipped',
  TechInterviewAvailable = 'me-lemon_tech_interview_is_availabe',
  TechInterviewBooked = 'me-lemon_tech_interview_is_booked',
  TechInterviewCompleted = 'me-lemon_tech_interview_is_completed',
  ProjectOfferDeclined = 'me-lemon_project_offer_declined',
  ProjectApplicationSubmitted = 'me-lemon_project_application_submitted',
  ProjectApplicationWithdrawn = 'me-lemon_project_application_withdrawn',
}

export enum ApplicationSource {
  Offer = 'offer',
  Self = 'self',
}

export const projectApplicationMEvent = (
  event:
    | MEvents.ProjectOfferDeclined
    | MEvents.ProjectApplicationSubmitted
    | MEvents.ProjectApplicationWithdrawn,
  dealId: string,
  source: ApplicationSource
) => {
  mixpanel.track(event, { deal_id: dealId, application_source: source });
};

export const fieldUpdatedMEvent = (
  field_name: string,
  field_previous_value: unknown,
  field_updated_value: unknown
) => {
  mixpanel.track(MEvents.FieldUpdated, {
    field_name,
    field_previous_value,
    field_updated_value,
  });
};

export const PageViewedMEvent = (path: string) => {
  const pageName = ((path.split('/')[1].match(/^[a-z0-9-]+/gi) || [])[0] || '')
    .toLowerCase()
    .replaceAll('-', '_');

  if (pageName) {
    mixpanel.track(MEvents.PageViewed, {
      page_name: pageName,
    });
  }
};
